import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import './styles/header.css';
//import './styles/font-awesome-4.7.0/css/font.awesome.min.css';


class Header extends Component{

  render(){
      const hamburgerToggle = ()=>{
          var links = document.getElementById("hamburgerLinks");
          if (links.style.display === "block") {
            links.style.display = "none";
          } else {
            links.style.display = "block";
          }
        };
      
      const hideHamburgerLinks = ()=>{
          console.log("hideHamburgerLinks");
          var links = document.getElementById("hamburgerLinks");
          links.style.display = "none";
      }
      window.addEventListener("deviceorientation", hideHamburgerLinks, true);
      
    return(
        <nav className="header">
        
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-LV6FZ6Z10M"></script>
            <script>
                window.dataLayer = window.dataLayer || [];
                gtag()=>dataLayer.push(arguments);
                gtag('js', new Date());
                gtag('config', 'G-LV6FZ6Z10M');                
            </script>
      
            <NavLink to="/"><div id="logo">Charles Brandt</div></NavLink>
            <ul className = "socialLinks">
                <li><a target ="_blank" rel="noopener noreferrer" href="https://github.com/luftbuefel"><img src="./images/github.png" alt="link to github"/></a></li>
                <li><a target ="_blank" rel="noopener noreferrer" href="https://www.instagram.com/makingitwithcharles/"><img src="./images/instagram.png" alt="link to instagram"/></a></li>
                <li><a target ="_blank" rel="noopener noreferrer" href="https://makingitwithcharles.tumblr.com"><img src="./images/tumblr.png" alt = "link to tumblr"/></a></li>
                <li><a href="./documents/charlesBrandtResume2025.pdf">.pdf résumé</a></li>
            </ul>
          
            <div id="headerLinks" className="desktop">                
                <ul>
                  <li><NavLink to="/about">ABOUT</NavLink></li>
                  <li><NavLink to="/games">GAMES</NavLink></li>
                  <li><NavLink to="/toys">TOYS</NavLink></li>
                  <li><NavLink to="/rAndD">RESEARCH AND DEVELOPMENT</NavLink></li>
                  <li><NavLink to="/animations">ANIMATIONS</NavLink></li>
                  <li><a href="https://makingitwithcharles.tumblr.com" rel="noreferrer" target="_blank">BLOG</a></li>
                  <li><NavLink to="/resume">RÉSUMÉ</NavLink></li>
                </ul>
            </div>
            <div id="hamburgerNav" className="mobile">
                <button className="mobile" id="hamburgerButton"  onClick={hamburgerToggle}>&#8801;</button>
                <div style={{display:'none'}} id="hamburgerLinks">
                    <NavLink to="/about" onClick={hideHamburgerLinks}>ABOUT</NavLink>
                    <NavLink to="/games" onClick={hideHamburgerLinks}>GAMES</NavLink>
                    <NavLink to="/toys" onClick={hideHamburgerLinks}>TOYS</NavLink>
                    <NavLink to="/rAndD" onClick={hideHamburgerLinks}>RESEARCH AND DEVELOPMENT</NavLink>
                    <NavLink to="/animations" onClick={hideHamburgerLinks}>ANIMATIONS</NavLink>
                    <a href="https://makingitwithcharles.tumblr.com" rel="noreferrer" target="_blank">BLOG</a>
                    <NavLink to="/resume" onClick={hideHamburgerLinks}>RÉSUMÉ</NavLink>
                </div>
            </div>
         
        </nav>
    );
  }
}

export default Header;
